let isFirstLoad = true;
async function generateHmacSha256(message, secretKey) {
  const enc = new TextEncoder();
  const key = await crypto.subtle.importKey(
    "raw",
    enc.encode(secretKey),
    { name: "HMAC", hash: "SHA-256" },
    false,
    ["sign"]
  );
  const signature = await crypto.subtle.sign("HMAC", key, enc.encode(message));
  return Array.from(new Uint8Array(signature))
    .map(b => b.toString(16).padStart(2, '0'))
    .join('');
}

async function getFreshAuth() {
  const shopPermanentDomain = "levis-india-store.myshopify.com";
  const timestamp = Date.now().toString();
  const marmeto_string_1 = timestamp.substring(0, 4);
  const marmeto_string_2 = timestamp.substring(4);

  const baseString = marmeto_string_1 + shopPermanentDomain + marmeto_string_2;
  const marmeto_hash = await generateHmacSha256(baseString, "yTGfof2MPlM1bLlvKSM");

  return {
    key: marmeto_hash,
    timestamp: timestamp,
  };
}

async function applyCartDiscount() {
  const cartDrawer = document.querySelector("cart-drawer.drawer");
  let customerPhoneNo = cartDrawer.getAttribute("data-customerPhone");

  if (customerPhoneNo?.length > 10 && customerPhoneNo.startsWith("+91")) {
    customerPhoneNo = customerPhoneNo.slice(3);
  }

  const requestInfo = {
    easy_id: customerPhoneNo,
    store_code: "EcommerceLevis",
    country_code: "91",
  };
  
  let timestamp = null;
  let key = null;
    
  const authData = await getFreshAuth();
  if (!authData) return;
  timestamp = authData.timestamp;
  key = authData.key;

  try {
    const transactionResponse = await fetch(
      "https://leviseasyrewards.marmeto.com/api/get/customer/transaction-details",
      {
        method: "POST",
        headers: {
          hash: key,
          timestamp: timestamp,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestInfo),
      }
    );
    
    const transactionData = await transactionResponse.json();
    const transactionList =
      transactionData?.data?.MemberTransactionResponseListDTO;

    const isNotMember =
      transactionList[transactionList.length - 2].BillNo.includes(
        "Bonus_Lapse"
      );
    
    if (isNotMember) {
      const nonMemberItemPrice = cartDrawer.querySelectorAll(
        "#CartDrawer-CartItems .cart-item"
      );
      
      nonMemberItemPrice.forEach((item) => {
        let discountCouponContainer = item.querySelector('.cart-item__details .discounts');
        const discountCouponEl = item.querySelector('.cart-item__details .redtap-discount-container');
        
        if (discountCouponEl) {
          discountCouponEl.classList.add('!tw-hidden');
          const visibleChildren = Array.from(discountCouponContainer.children).filter(child => {
            return child !== discountCouponEl && child.offsetParent !== null;
          });
        
          if (visibleChildren.length === 0) {
            discountCouponContainer.classList.add('!tw-hidden');
          } else {
            discountCouponContainer.classList.remove('!tw-hidden');
          }
        }
        let itemPriceContainer = item.querySelector('.cart-item__final-price');
        let discountPercentageEl = item.querySelector('.cart-item__old-price--discount');
        const cartItemPrice = item.getAttribute('data-actual-price');
        const cartItemCompare = item.getAttribute('data-compare-at-price')
        let discountPercentage = ((cartItemCompare - cartItemPrice)*100)/cartItemCompare;
        discountPercentageEl.textContent = `${parseInt(discountPercentage)}% OFF`

        if (itemPriceContainer && cartItemPrice) {
          const actualPrice = Number(cartItemPrice).toLocaleString("en-IN", {
            style: "currency",
            currency: "INR",
          });
          
          itemPriceContainer.innerHTML = actualPrice;
        }
      });
    }  
    if (
      Array.isArray(transactionList) &&
      transactionList.length > 0 &&
      !isNotMember
    ) {
      const cartFooter = cartDrawer.querySelector(".drawer__footer");
      const cartTotal = parseInt(
        cartDrawer
          .querySelector("cart-drawer-items")
          .getAttribute("data-cart-total")
      );
      let cartTotalPriceAfterDiscount = 0;
      const cartLineItems = cartDrawer.querySelectorAll(
        "#CartDrawer-CartItems .cart-item"
      );
      cartLineItems.forEach((cartItem) => {
        const itemPrice = cartItem.getAttribute("data-item-price");
        cartTotalPriceAfterDiscount += parseInt(itemPrice);
        let discountCouponContainer = cartItem.querySelector('.cart-item__details .discounts');
        let redtapDiscountContainer = discountCouponContainer.querySelector('.redtap-discount-container');

        if (redtapDiscountContainer) {
          discountCouponContainer.classList.remove('!tw-hidden');
          redtapDiscountContainer.classList.remove("!tw-hidden");
        } else {
          discountCouponContainer.classList.add('!tw-hidden');
        }
      });
      
      const discountAmount = cartTotal - cartTotalPriceAfterDiscount;
      const additionalDiscount = discountAmount.toLocaleString("en-IN", {
        style: "currency",
        currency: "INR",
      });
      const finalPrice = cartTotalPriceAfterDiscount.toLocaleString("en-IN", {
        style: "currency",
        currency: "INR",
      });
      const cartTotalFinal = cartTotal.toLocaleString("en-IN", {
        style: "currency",
        currency: "INR",
      });
      
      // Update discount UI
      let discountDiv = cartFooter.querySelector(".automatic-coupon");
      const discountHTML = `
        <p class="tw-text-[12px] tw-tracking-normal tw-leading-normal tw-text-[#000] tw-font-primary tw-upppercase">
          <span>Use Code: <span class="tw-font-secondary tw-uppercase redtab-discount-code">Red Tab Member Bonus</span></span> 
        </p>`;
      
      if (discountDiv) {
        if (discountDiv.classList.contains("redtap-discount-container")) {
          discountDiv.innerHTML = discountHTML;
        }
      } else {
          discountDiv = document.createElement("div");
          discountDiv.classList.add(
            "automatic-coupon",
            "redtab-discount-container",
            "tw-w-full",
            "tw-bg-[#f7f2e5]",
            "tw-items-center",
            "tw-py-2",
            "tw-px-1",
            "tw-flex",
            "tw-gap-4",
            "tw-justify-center",
            "tw-cursor-pointer"
          );
          if (discountAmount == 0){
            discountDiv.classList.add('!tw-hidden')
          };
          discountDiv.innerHTML = discountHTML;
          cartFooter.prepend(discountDiv);
      }

      const cartTotalContainer = cartFooter.querySelector(
        ".totals__subtotal-value"
      );
      
      if (cartTotalContainer && cartTotalFinal != finalPrice && false) {
        cartTotalContainer.innerHTML = `
          <s class="tw-text-[12px] lg:tw-text-[14px] tw-font-primary tw-tracking-normal tw-text-[#767B78] cart-compare-price selection">
            ${cartTotalFinal}
          </s>
          <span class="tw-font-primary cart-final-price">
            ${finalPrice}
          </span>`;
      }
    }
  } catch (error) {
    console.error("❌ Error applying cart discount:", error);
    let isNotMember = true;
    if (isNotMember) {
      const nonMemberItemPrice = cartDrawer.querySelectorAll(
        "#CartDrawer-CartItems .cart-item"
      );
      
      nonMemberItemPrice.forEach((item) => {
        let discountCouponContainer = item.querySelector('.cart-item__details .discounts');
        const discountCouponEl = item.querySelector('.cart-item__details .redtap-discount-container');
        
        if (discountCouponEl) {
          discountCouponEl.classList.add('!tw-hidden');
          const visibleChildren = Array.from(discountCouponContainer.children).filter(child => {
            return child !== discountCouponEl && child.offsetParent !== null;
          });
        
          if (visibleChildren.length === 0) {
            discountCouponContainer.classList.add('!tw-hidden');
          } else {
            discountCouponContainer.classList.remove('!tw-hidden');
          }
        }
        let itemOldPriceEl = item.querySelector('.cart-item__old-price');
        let itemPriceContainer = item.querySelector('.cart-item__final-price');
        let discountPercentageEl = item.querySelector('.cart-item__old-price--discount');
        const cartItemPrice = item.getAttribute('data-actual-price');
        const cartItemCompare = item.getAttribute('data-compare-at-price')
        let discountPercentage = ((cartItemCompare - cartItemPrice)*100)/cartItemCompare;
        discountPercentageEl.textContent = `${parseInt(discountPercentage)}% OFF`
        discountPercentageEl.classList.add('!tw-hidden');
        itemOldPriceEl.classList.add('!tw-hidden');
        if (itemPriceContainer && cartItemPrice) {
          const actualPrice = Number(cartItemPrice).toLocaleString("en-IN", {
            style: "currency",
            currency: "INR",
          });
          
          itemPriceContainer.innerHTML = actualPrice;
        }
      });
    } 
  }
}

applyCartDiscount();

["add_to_cart", "cart-item-removed", "change"].forEach((eventName) => {
  document.addEventListener(eventName, () => {
    if (eventName === "change") {
      const targetInput = event.target;
      const insideQuantityInput = targetInput.closest("quantity-input");
      const insideCart = targetInput.closest("cart-drawer-items");
      
      if (!(insideQuantityInput && insideCart)) {
        return;
      }
    }
    isFirstLoad = false;
    setTimeout(() => {
      applyCartDiscount();
    }, 100);
  });
});
document.addEventListener("cart-updated", () => {
  isFirstLoad = false;
  applyCartDiscount();
});

// --- Copy-to-clipboard for Red Tab bonus (robust + works with dynamic DOM) ---
function showCopiedMessage(targetBlock) {
  const message = document.createElement("span");
  message.innerText = "Copied!";
  message.className = "copied-message";
  message.style.cssText = `
    position: absolute;
    background: #c41320;
    color: white;
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 12px;
    top: -20px;
    right: 10px;
    z-index: 1000;
    animation: fadeOut 2s forwards;
  `;
  targetBlock.style.position = targetBlock.style.position || "relative";
  targetBlock.appendChild(message);
  setTimeout(() => message.remove(), 2000);
}

// Use event delegation so it also works for elements added later
document.addEventListener("click", async (e) => {
  const container = e.target.closest(".redtab-discount-container");
  if (!container) return;

  const code = container.querySelector(".redtab-discount-code")?.textContent?.trim();
  if (!code) return;

  try {
    await navigator.clipboard.writeText(code);
  } catch (err) {
    // Fallback for older browsers or if Clipboard API is blocked
    const ta = document.createElement("textarea");
    ta.value = code;
    ta.setAttribute("readonly", "");
    ta.style.position = "fixed";
    ta.style.top = "-9999px";
    document.body.appendChild(ta);
    ta.select();
    document.execCommand("copy");
    document.body.removeChild(ta);
  }

  showCopiedMessage(container);
});
